import { Outlet } from 'react-router-dom';
import { LiveProvider } from '@/lib/live';
import { useEmergencyNotifications } from '@/features/feed/useEmergencyAlerts';
import { NavRail } from './NavRail';
import { StatusBar } from './StatusBar';

/** Must sit inside LiveProvider, which is why it is a child rather than inline. */
function Shell() {
  // Mounted here so an urgent post notifies whichever screen is open.
  useEmergencyNotifications();

  return (
    <div className="flex h-dvh overflow-hidden">
      <NavRail />
      <div className="flex min-w-0 flex-1 flex-col">
        <StatusBar />
        <main className="min-h-0 flex-1 overflow-hidden p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export function AppShell() {
  return (
    <LiveProvider>
      <Shell />
    </LiveProvider>
  );
}
